import React, { useState, useEffect } from 'react';
import { Container, Alert, Row, Col, Form, Button } from "react-bootstrap";
import { buildUrl } from '../helper/handler';
import { getFromApi, downloadCsv } from '../utilities/NetUtilities';
import { SpinnerComp } from '../helper/spinner';
import TabellaPianoFerie from './TabellaPianoFerie';
import moment from 'moment';
import 'moment/locale/it';
import { FaSquare } from 'react-icons/fa';

moment.locale('it');

function PianoFerie() {
    const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().add(30, 'days').format('YYYY-MM-DD'));
    const [pianoFerieData, setPianoFerieData] = useState({});
    const [lavoratori, setLavoratori] = useState([]);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({});
    const [organizzazione, setOrganizzazione] = useState(null);
    
    useEffect(() => {
        const org = JSON.parse(window.sessionStorage.getItem("organizzazione"));
        if (org) {
            setOrganizzazione(org);
        } else {
            setMessage({ tipo: 'danger', descrizione: 'Organizzazione non trovata. Selezionare un\'organizzazione dalla Home.' });
        }
    }, []);
    
    useEffect(() => {
        if (!organizzazione || !startDate || !endDate) {
            setPianoFerieData({}); 
            setLavoratori([]);
            return;
        }

        if (moment(endDate).isBefore(moment(startDate))) {
            setMessage({ tipo: 'warning', descrizione: 'La data di fine non può essere antecedente alla data di inizio.' });
            setPianoFerieData({});
             setLavoratori([]);
            return;
        }

        const fetchData = () => {
            setLoading(true);
            setMessage({});

            const params = {
                organizzazione: organizzazione.nome,
                tipo: organizzazione.tipo,
                inizio: startDate,
                fine: endDate
            };
            const url = buildUrl('pianoferie', params);

            const okAction = (data) => {
                setPianoFerieData(data.feriePermessi || {});
                setLavoratori(data.lavoratori || []);
                setLoading(false);
                if (!data.lavoratori || data.lavoratori.length === 0) {
                     setMessage({ tipo: 'info', descrizione: 'Nessun lavoratore trovato per questa organizzazione.' });
                }
            };

            const errorAction = (error) => {
                setMessage({ tipo: error.messaggi?.[0]?.tipo || 'danger', descrizione: error.messaggi?.[0]?.descrizione || 'Errore nel caricamento dei dati.' });
                setLoading(false);
                setPianoFerieData({});
                setLavoratori([]);
            };

            getFromApi(url, okAction, errorAction);
        };

        fetchData();

    }, [startDate, endDate, organizzazione]);

    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
    };

    const handleEndDateChange = (e) => {
        setEndDate(e.target.value);
    };

     const handleCloseAlert = () => {
        setMessage({});
    }

    const handleDownloadCsv = () => {
        if (!organizzazione || !startDate || !endDate) {
            setMessage({ tipo: 'warning', descrizione: 'Selezionare un intervallo di date valido.' });
            return;
        }

        const params = {
            organizzazione: organizzazione.nome,
            tipo: organizzazione.tipo,
            inizio: startDate,
            fine: endDate
        };
        const url = buildUrl('downloadPianoFerieCsv', params);
        downloadCsv(url, 'piano_ferie.csv');
    };

    return (
        <div className='main' role='main' onClick={handleCloseAlert}>
            <Container fluid>
                <h1 className="d-flex justify-content-center inEvidenza" id="title_piano_ferie">Piano Ferie</h1>

                {message.descrizione && (
                    <Alert variant={message.tipo} id="message">
                        {message.descrizione}
                    </Alert>
                )}

                <Row className="d-flex justify-content-center mb-3 align-items-end">
                    <Col md={4} sm={6} xs={12}>
                        <Form.Group>
                            <Form.Label htmlFor='start-date' className="inEvidenza">Data Inizio</Form.Label>
                            <Form.Control
                                type="date"
                                id="start-date"
                                value={startDate}
                                onChange={handleStartDateChange}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4} sm={6} xs={12}>
                        <Form.Group>
                            <Form.Label htmlFor='end-date' className="inEvidenza">Data Fine</Form.Label>
                            <Form.Control
                                type="date"
                                id="end-date"
                                value={endDate}
                                onChange={handleEndDateChange}
                            />
                        </Form.Group>
                    </Col>
                </Row>

                {loading ? (
                    <SpinnerComp />
                ) : (
                    lavoratori.length > 0 && Object.keys(pianoFerieData).length > 0 ? (
                        <>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <div className='legenda'>
                                    <FaSquare className='boxLegendaFerie'></FaSquare> <span>ferie  </span> <FaSquare className='boxLegendaPermesso'></FaSquare> <span>permesso</span>
                                </div>
                                <Button
                                    id="download-csv-piano-ferie"
                                    title="Download CSV"
                                    className="btnGeneraleVariante"
                                    variant="flat"
                                    size="sm"
                                    onClick={handleDownloadCsv}
                                >
                                    Scarica
                                </Button>
                            </div>
                            <TabellaPianoFerie
                                startDate={startDate}
                                endDate={endDate}
                                lavoratori={lavoratori}
                                pianoFerieData={pianoFerieData}
                            />
                        </>
                    ) : (
                         !loading && organizzazione && <p className="text-center">Nessun dato sul piano ferie da visualizzare per il periodo selezionato.</p>
                    )
                )}
            </Container>
        </div>
    );
}

export default PianoFerie;